// extracted by mini-css-extract-plugin
export var change = "styles-module--change--VtB7j";